"use client"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog"

import type { YasalBelge } from "../types"
import { YasalBelgeIcerik } from "./yasal-belge-icerik"

interface YasalBelgeDialogProps {
  belge: YasalBelge
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function YasalBelgeDialog({ belge, open, onOpenChange }: YasalBelgeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[85svh] flex-col gap-0 p-0 sm:max-w-2xl">
        <DialogHeader className="border-b px-6 py-4 pe-12 text-left">
          <DialogTitle>{belge.baslik}</DialogTitle>
          {belge.altBaslik && <DialogDescription>{belge.altBaslik}</DialogDescription>}
        </DialogHeader>
        <div className="overflow-y-auto px-6 py-5">
          <YasalBelgeIcerik belge={belge} baslikGizle />
        </div>
      </DialogContent>
    </Dialog>
  )
}
